module.exports = __webpack_public_path__ + "static/media/headerLogo.6497d65a.png";